module.exports = __webpack_public_path__ + "assets/app/img/ie-select-edge.png";


//////////////////
// WEBPACK FOOTER
// ./src/main/images/ie-select-edge.png
// module id = TEhP
// module chunks = 1